import { render, staticRenderFns } from "./DBBot.vue?vue&type=template&id=4b490b6e&"
import script from "./DBBot.vue?vue&type=script&lang=js&"
export * from "./DBBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports